export default {"src":"/_next/static/media/completed-checkmark.52152d23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};